import styled from 'styled-components';

export const SFlexDiv = styled.div`
  flex: 1;
`;
